// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"4891108a","239":"037fe9ec","453":"ab43f3c6"}[chunkId] + ".chunk.js";
};